import React from "react";
import PageTitle from "../../assets/images/city-image-navigation.jpeg";
import { products } from "../../data/products";
import TTSForm from "../../components/common/TTSForm";
export default function KrediKartiIleShellTasitTanima() {
  const pageImage = products.find((p) => p.link === window.location.pathname)?.img;

  return (
    <div className="container-fluid animate pageWrapper">
      {/* <!--Page--> */}
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>Kredi Kartı İle Shell Taşıt Tanıma</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="/urunler">Ürünler</a>{" "}
                  {">"} <a href="#">Kredi Kartı İle Shell Taşıt Tanıma</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  <b>Kredi Kartı İle Shell Taşıt Tanıma</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row mt-3 start-sm center-xs">
              {/* <!--urun--> */}
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <img
                      src={pageImage ?? ""}
                      height="263"
                      width="375"
                    />
                  </span>
                </div>
              </div>
              {/* <!--/urun--> */}
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div className="textCapsule">
                  <p>
                    <b>
                      Shell Taşıt Tanıma Sistemi ile entegre kredi kartı
                      &ouml;deme se&ccedil;eneği, &ouml;n &ouml;demesiz ve
                      blokesiz akaryakıt ikmali sağlamaktadır.
                    </b>
                  </p>

                  <h3>
                    Filo ara&ccedil;larına, hızlı ve kolay yakıt ikmalini
                    sağlamaya yardımcı yeni &ouml;deme y&ouml;ntemi şimdi Shell
                    TTS&rsquo;de.
                  </h3>

                  <p>
                    DBS ya da Teminat mektubu gerektirmeden kredi kartı ile
                    &ouml;n &ouml;demesiz ve blokesiz hizmet!
                  </p>

                  <p>
                    Firmalar ve KOBİ&rsquo;ler kredi kartı &ouml;deme
                    y&ouml;ntemi ile kredi kartlarını Shell TTS web sitesi
                    &uuml;zerinden tanımlayarak şirket ara&ccedil;larının yakıt
                    alımlarını y&ouml;netebilirler.
                  </p>

                  <h4>T&uuml;m Kredi Kartları i&ccedil;in Uygun Altyapı</h4>

                  <p>
                    Debit hari&ccedil; t&uuml;m kredi kartları ile uyumlu sistem
                  </p>

                  <h4>Birden Fazla Kart Ekleme Se&ccedil;enegi</h4>

                  <p>
                    Web sitesi &uuml;zerinden kart ekleme, kartların sorgu
                    sıralamalarını belirleme imk&acirc;nı
                  </p>

                  <h4>&Ouml;n Blokesiz Sistem</h4>

                  <p>
                    Kredi kartında limit ayrımına gerek olmadan yakıt ikmali
                    fırsatı
                  </p>

                  <h4>PCI-DSS Uyumlu SSL Sertifikalı</h4>

                  <p>
                    G&uuml;venli alısveris i&ccedil;in, kullanılacak kredi
                    kartlarının web sitesi &uuml;zerinden 1 defaya mahsus olmak
                    &uuml;zere 3D secure sistemiyle kaydedilmesi
                  </p>
                </div>
              </div>
            </div>
            {/* <!--/urunler--> */}
          </div>
        </div>
        {/* <!--/page--> */}
        {/* <!--talep-formu--> */}
        <div className="container-fluid section page-form-section">
          <div className="container-fluid container">
            {/* <!--Text--> */}
          
            {/* <!--/Text--> */}
            <TTSForm />
          </div>
        </div>
        {/* <!--/talep-formu--> */}
      </div>
      {/* <!--//Page--> */}
    </div>
  );
}
